module.exports = __webpack_public_path__ + "static/media/foggy.6b6d60dd.png";